module.exports = __webpack_public_path__ + "static/media/bu.5576549b.png";